import { WorkspaceTabsAction } from './actions';
import { MAX_WORKSPACE_TABS, WorkspaceTabsActionTypes, WorkspaceTabsState } from './types';

const INIT_STATE: WorkspaceTabsState = {
  tabs: [],
  activeKey: null,
};

const WorkspaceTabs = (state: WorkspaceTabsState = INIT_STATE, action: WorkspaceTabsAction): WorkspaceTabsState => {
  switch (action.type) {
    case WorkspaceTabsActionTypes.OPEN_TAB: {
      const existing = state.tabs.find((tab) => tab.key === action.payload.key);
      if (existing) {
        return {
          ...state,
          activeKey: action.payload.key,
          tabs: state.tabs.map((tab) =>
            tab.key === action.payload.key
              ? {
                  ...tab,
                  title: action.payload.title || tab.title,
                  pathname: action.payload.pathname,
                  search: action.payload.search,
                }
              : tab
          ),
        };
      }
      if (state.tabs.length >= MAX_WORKSPACE_TABS) {
        return state;
      }
      return {
        ...state,
        tabs: [...state.tabs, action.payload],
        activeKey: action.payload.key,
      };
    }
    case WorkspaceTabsActionTypes.ACTIVATE_TAB:
      return {
        ...state,
        activeKey: action.payload,
      };
    case WorkspaceTabsActionTypes.CLOSE_TAB: {
      const index = state.tabs.findIndex((tab) => tab.key === action.payload);
      if (index === -1) {
        return state;
      }
      const tabs = state.tabs.filter((tab) => tab.key !== action.payload);
      let activeKey = state.activeKey;
      if (state.activeKey === action.payload) {
        const next = tabs[index] || tabs[index - 1] || null;
        activeKey = next ? next.key : null;
      }
      return { tabs, activeKey };
    }
    case WorkspaceTabsActionTypes.UPDATE_TAB_TITLE:
      return {
        ...state,
        tabs: state.tabs.map((tab) =>
          tab.key === action.payload.key ? { ...tab, title: action.payload.title } : tab
        ),
      };
    case WorkspaceTabsActionTypes.CLEAR_TABS:
      return INIT_STATE;
    default:
      return state;
  }
};

export default WorkspaceTabs;
